module.exports = __webpack_public_path__ + "img/what-is-an-api-thumbnail.392e6d01.jpg";